import React, { Component } from "react";
import { injectIntl } from "react-intl";
import "./ChatDescription.scss";

class ChatDescription extends Component {
  getFlags() {
    let flags = (this.props.chat && this.props.chat.flags) || [];
    let formattedFlags = [];

    for (let i = 0; i < flags.length; i++) {
      let currentFlagModel =
        this.props.flags &&
        this.props.flags.find((elem) => elem.id === flags[i].id);
      if (currentFlagModel) {
        formattedFlags.push(
          <span
            className="element-description tag"
            key={`flag-${currentFlagModel.id}`}
            style={{ backgroundColor: currentFlagModel.color }}
          >
            {currentFlagModel.flagName}
          </span>
        );
        formattedFlags.push(
          <span className="bullet" key={`bullet-${currentFlagModel.id}`}>
            {" "}
            &#8226;{" "}
          </span>
        );
      }
    }
    return formattedFlags;
  }

  getDescriptionElements() {
    let elements = (this.props.chat && this.props.chat.elements) || [];
    let descriptionElements =
      window.Social.getChatConfig().chatDescriptionElements;
    let foundElements = [];

    if (elements) {
      for (let i = 0; i < descriptionElements.length; i++) {
        let element = elements.find(
          (elem) => elem.description === descriptionElements[i]
        );
        element && foundElements.push(element);
      }
    }
    return foundElements;
  }

  formatDescriptionElements(elements) {
    if (elements.length > 0) {
      return elements.map((elem, index) => {
        let element = [];
        element.push(
          <span className="element-description" key={`element-${index}`}>
            {elem.content}
          </span>
        );
        index < elements.length - 1 &&
          element.push(
            <span className="bullet" key={`element-${index}-bullet`}>
              {" "}
              &#8226;{" "}
            </span>
          );
        return element;
      });
    } else {
      return (
        <span className="element-description">
          {window.Social.getChatConfig().emptyDescription}
        </span>
      );
    }
  }

  getPrivacy() {
    let elements =
      (this.props.chat &&
        (this.props.chat.elements ||
          (this.props.chat.draft && this.props.chat.draft.elements))) ||
      [];
    let privacy = elements.find(
      (elem) =>
        elem.description === window.Social.getChatConfig().privacyElement
    );
    let privacyFormatted;
    let privacyModel = [];
    if (privacy && privacy.content) {
      let privacyModel = Object.values(
        window.Social.getPrivacyTypesConfig()
      ).find((elem) => elem.value === privacy.content);
      if (privacyModel && !privacyModel.hiddenOnDescription) {
        privacyFormatted = this.props.intl.formatMessage({
          id: privacyModel.title,
        });
      }
    }
    if (privacyFormatted) {
      privacyModel.push(
        <span key="privacy-description" className="element-description">
          {privacyFormatted}
        </span>,
        <span className="bullet" key="privacy-bullet">
          {" "}
          &#8226;{" "}
        </span>
      );
    }
    return privacyModel;
  }

  getDescription() {
    let flags = window.Social.getChatConfig().allowFlags ? this.getFlags() : [];
    let privacy = this.getPrivacy();
    let foundElements = this.getDescriptionElements();
    let formattedElements = this.formatDescriptionElements(foundElements);

    return {
      flags,
      privacy,
      formattedElements,
    };
  }

  render() {
    const { flags, privacy, formattedElements } = this.getDescription();
    return (
      <div className="chat-description">
        {flags}
        {privacy}
        {formattedElements}
      </div>
    );
  }
}

export default injectIntl(ChatDescription);
